import React, { useState, useEffect } from "react";

const Loader = ({ progress }) => {
  return (
    <div>
      <p className="text-center">Loading... {Math.round(progress)}%</p>
    </div>
  );
};

const ImageLoader = ({ src, alt, width, height }) => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", src, true);
    xhr.responseType = "blob";

    xhr.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        setProgress(percentComplete);
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const imgUrl = URL.createObjectURL(blob);
        setImageSrc(imgUrl);
        setLoading(false);
      } else {
        console.error("Failed to load image", xhr.status);
      }
    };

    xhr.onerror = () => {
      console.error("Image request failed");
    };

    xhr.send();

    // Cleanup on unmount
    return () => {
      xhr.abort();
    };
  }, [src]);

  return (
    <div
      style={{
        width: width ? width : "600px",
        height: height ? height : "500px",
        cursor: "pointer",
      }}
    >
      {loading && (
        <div
          style={{
            width: width ? width : "600px",
            height: height ? height : "500px",
            backgroundColor: "#00000050",
          }}
        >
          <Loader loading={loading} progress={progress} />
        </div>
      )}
      {imageSrc && (
        <img
          src={src}
          alt={alt}
          style={{
            width: width ? width : "600px",
            height: height ? height : "500px",
          }}
        />
      )}
    </div>
  );
};

export default ImageLoader;
